<template>
  <v-app class="app" v-scroll="onScroll">
    <div class="wrapper">
      <div class="content">
        <router-view name="navbar"></router-view>
        <v-navigation-drawer
          class="d-lg-none v-navigation-drawer--fixed navbar__menu__drawer"
          style="z-index: 10000"
          v-model="$store.state.drawer"
          absolute
          temporary
          right
          dark
          color="#2F2E43"
        >
          <v-btn
            @click="$store.state.drawer = !$store.state.drawer"
            icon
            x-large
            class=" ma-2"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-list class="navbar__menu__drawer-list">
            <div class="" v-for="(item, index) in menuItems" :key="index">
              <v-list-group color="#FFA903" v-if="item.child.length">
                <template v-slot:activator>
                  <v-list-item-title class="px-4">{{
                    item.title
                  }}</v-list-item-title>
                </template>

                <div
                  class=""
                  v-for="subItem in item.child"
                  :key="subItem.title"
                >
                  <v-list-group
                    no-action
                    sub-group
                    class="px-8"
                    color="#FFA903"
                    v-if="subItem.child.length"
                  >
                    <template v-slot:activator>
                      <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="subsubItem in subItem.child"
                        :key="subsubItem.title"
                      >
                        <v-list-item-title class="px-10">{{
                          subsubItem.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-list-group>
                  <div v-else>
                    <v-list-item v-if="subItem.href">
                      <v-list-item-title class="px-8">
                        <a
                          class="menuLink"
                          :href="require(`@/assets/${subItem.href}`)"
                          target="_blank"
                        >
                          {{ subItem.title }}
                        </a>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-else :to="subItem.url">
                      <v-list-item-title class="px-8">{{
                        subItem.title
                      }}</v-list-item-title>
                    </v-list-item>
                  </div>
                </div>
              </v-list-group>
              <v-list-item color="#FFA903" :to="item.url" v-else>
                <v-list-item-title class="px-4">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list>
        </v-navigation-drawer>
        <router-view name="bottomNav"></router-view>
        <div class="content">
          <router-view></router-view>
        </div>
      </div>

      <div class="footer__wrapper" v-if="this.$route.name !== 'NotFound'">
        <Footer class=""></Footer>
        <v-footer
          v-if="$vuetify.breakpoint.xsOnly"
          class="footer__rights py-8"
          dark
          color="#29273C"
        >
          <div class="text-center footer__rights-text">
            © {{ copyrightText }}. Lsaran 2025
          </div>
        </v-footer>
      </div>
    </div>
  </v-app>
</template>

<script>
import Footer from "@/components/Footer";
import { isPassedSessionKey } from "@/utils/sessionKey";
export default {
  name: "App",

  props: [],

  components: {
    Footer
  },

  computed: {
    menuItems() {
      return this.$t("common").menuItems ?? [];
    },
    copyrightText() {
      return this.$t("footer").copyrightText ?? "";
    }
  },

  data: () => ({
    loading: true
  }),
  mounted() {
    this.$store.dispatch("loadMainInfo");
    const sessionKey = localStorage.getItem("session-key");
    if (sessionKey && !isPassedSessionKey(JSON.parse(sessionKey))) {
      this.$store.dispatch("setSessionKey", JSON.parse(sessionKey));
    } else {
      localStorage.clear();
    }
  },

  methods: {
    onScroll(e) {
      this.$store.state.pageScroll =
        window.pageYOffset || e.target.scrollTop || 0;
      const footer = document.getElementById("footer");
      const footerHeight = footer.getBoundingClientRect().height;
      this.$store.state.scrollBottomPage =
        footer.getBoundingClientRect().bottom < screen.height + footerHeight;
      //top > 20 ? this.navbarScroll = true : this.navbarScroll = false
    }
  }
};
</script>

<style lang="sass">
@import "assets/style/vars"

.navbar
  &__menu
    flex-wrap: wrap
    justify-content: center
    &__drawer
      &-list
        margin-top: 30%

.footer__rights
  width: 100%
  font-size: 13px
  line-height: 21px
  text-align: center !important
  &-text
    width: 100%
    text-align: center !important

.wrapper
  display: flex
  flex-direction: column
  height: 100%

.content
  flex: 1 0 auto !important

.footer__wrapper
  flex-shrink: 0 !important

.menuLink
  color: inherit !important
</style>
